import { createSlice } from '@reduxjs/toolkit';
import actions from './reportsSection.actions';
import { IReportsSectionInitial } from './reportsSection.types';

const reportsSectionInitialState: IReportsSectionInitial = {
  generationReport: {
    startedAt: 0,
    finishedAt: 0,
    isReportShown: false,
    isTimedOut: false,
  },
  sendingReport: {
    startedAt: 0,
    finishedAt: 0,
    isReportShown: false,
    isTimedOut: false,
  },
};

const reportsSection = createSlice({
  name: 'reportsSectionSlice',
  initialState: reportsSectionInitialState,
  reducers: actions,
});

export const reportsSectionReducer = reportsSection.reducer;
export const {
  setIsGenerationReportShown,
  setIsSendingReportShown,
  setGenerationStartedAt,
  setGenerationFinishedAt,
  setSendingStartedAt,
  setSendingFinishedAt,
  setGenerationIsTimedOut,
  setSendingIsTimedOut,
} = reportsSection.actions;
